/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { RoutePath } from 'shared/enums/RoutePath';
import { NotFound } from './NotFound';
import useProcedures from '../../procedure/useProcedures';

export function ProcedureRouteGuard({ children }) {
  const { procedures } = useProcedures();

  const location = useLocation();
  const routePaths = Object.values(RoutePath)
    .filter(obj => obj.hasOwnProperty('path'))
    .map(({ path }) => path);

  // check if the current location matches against an URL which doesn't contain a :procedure parameter
  const nonProcedurePaths = routePaths.filter(
    path => path !== RoutePath.DASHBOARD.path && !path.includes(':procedure'),
  );
  const matchNonProcedurePath = findMatchedPath(location.pathname, nonProcedurePaths);
  if (location.pathname === RoutePath.DASHBOARD.path || matchNonProcedurePath) {
    return children;
  }

  // check if the current location matches against an URL which contains a :procedure parameter
  const procedurePaths = routePaths.filter(path => path.includes(':procedure'));
  const matchProcedurePath = findMatchedPath(location.pathname, procedurePaths);
  const procedure = procedures[matchProcedurePath?.params?.procedure];
  if (procedure && procedure.enabled) {
    return children;
  }

  // return NotFound page if we don't find any matches
  return <NotFound />;
}

// find a match of pathName in an array of paths
function findMatchedPath(pathName, paths) {
  return paths.map(path => matchPath(pathName, { path })).find(path => path);
}
